import React, {Fragment} from 'react';
import {Chip, TableCell, Typography, useTheme} from '@mui/material';
import {Procedure} from 'domain/usecases';
import {formatPrice} from 'presentation/utils';

export const TableDesktopRow = (procedure: Procedure) => {
	const theme = useTheme();

	return (
		<Fragment>
			<TableCell>
				<Typography variant="caption" color="text.secondary">
					{procedure.cdProcedimento}
				</Typography>
			</TableCell>
			<TableCell
				component="th"
				scope="row"
				sx={{
					width: '100%',
				}}>
				<Typography
					sx={{
						width: '100%',
						borderLeft: `1px solid ${theme.palette.divider}`,
						pl: 2,
					}}>
					{procedure.nmProcedimento}{' '}
				</Typography>
			</TableCell>
			<TableCell align="right">
				<Chip
					label={formatPrice(procedure.valorProcedimento.toFixed(2))}
					sx={{
						height: 24,
						backgroundColor: theme.colors.light.primary['10Percent'],
						color: theme.palette.primary.main,
						borderRadius: '4px',
						fontWeight: 600,
					}}
				/>
			</TableCell>
		</Fragment>
	);
};
